import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@domain/auth/useAuth';
import { ROUTES } from "@shared/routes";

export function AuthListener({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, verificationFailed } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !verificationFailed) {
      const currentPath = window.location.pathname;
      const publicPaths: string[] = import.meta.env.DEV
        ? [ROUTES.login, ROUTES.authCallback, ROUTES.design]
        : [ROUTES.login, ROUTES.authCallback];
      const isPublicClass = currentPath.startsWith(ROUTES.classPrefix);

      if (!publicPaths.includes(currentPath) && !isPublicClass) {
        navigate(ROUTES.login, { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, verificationFailed, navigate]);

  return <>{children}</>;
}